import { HOMEOWNER_AUDIENCE, BUYER_AUDIENCE, RIPE_FOR_REFI_AUDIENCE, KCL_AUDIENCE } from '../../constants/customMailer'
import { createSelector } from 'reselect'
import moment from 'moment'

const selectCustomMailer = state => state.customMailer

export const selectCustomMailerAudience = createSelector(selectCustomMailer, mailer => mailer.audience)

export const selectCustomMailerVideoId = createSelector(selectCustomMailer, mailer => mailer.videoId)

export const selectCustomMailerVideoType = createSelector(selectCustomMailer, mailer => mailer.videoType)

const thirtyDaysAgo = moment().subtract(30, 'days').format()

export const selectShouldDisplayVideoForHomeDigest = createSelector(
  selectCustomMailer,
  mailer =>
    (mailer.audience === HOMEOWNER_AUDIENCE || mailer.audience === RIPE_FOR_REFI_AUDIENCE || mailer.audience === KCL_AUDIENCE) &&
    moment(mailer.createdAt).isAfter(moment(thirtyDaysAgo))
)

export const selectShouldDisplayVideoForBuyerDigest = createSelector(
  selectCustomMailer,
  mailer => (mailer.audience === BUYER_AUDIENCE || mailer.audience === KCL_AUDIENCE) && moment(mailer.createdAt).isAfter(moment(thirtyDaysAgo))
)

export const selectShouldDisplayEmailVideo = createSelector(
  selectShouldDisplayVideoForBuyerDigest,
  selectShouldDisplayVideoForHomeDigest,
  (displayForBuyer, displayForHome) => displayForHome || displayForBuyer
)
